import React from "react";
import Tooltip from "@mui/material/Tooltip";
import HelpFilledIcon from "@mui/icons-material/Help";
import CommonGrid from "./CommonGrid";
import InspectionStatementControl from "../InspectionStatementControl";
import { ColumnType } from "../../../../components/Grid/constants";
import {
  StatementTypeGrid,
  StatementStateInternal,
  StatementStateFilterItems,
  StatementState,
  StatementStateRaw,
  Visibility,
} from "../../enum";
import { FormattedDate, FormattedTime } from "react-intl";
import Button from "../../../../components/form/Button";
import FactCheckOutlinedIcon  from "@mui/icons-material/FactCheckOutlined";

const tooltipSx = {
  bgcolor: "rgba(97, 97, 97, 0.92)",
  color: "#fff",
  fontSize: "12px",
  maxWidth: 280,
  p: "8px 10px",
  borderRadius: "2px",
  lineHeight: 1.35,
  whiteSpace: "pre-wrap",
};

const ActionHelpPopover = ({ text }) => (
  <Tooltip
    title={text}
    placement="top"
    arrow
    enterDelay={100}
    aria-label={null}
    componentsProps={{
      tooltip: { sx: tooltipSx },
      arrow: { sx: { color: "rgba(97, 97, 97, 0.92)" } },
    }}
  >
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 18,
        height: 18,
        cursor: "pointer",
        flexShrink: 0,
      }}
    >
      <HelpFilledIcon
        style={{
          width: 15,
          height: 15,
          display: "block",
          color: "rgba(97, 97, 97, 0.75)",
        }}
      />
    </span>
  </Tooltip>
);

// const showLastDate = (row) => {
//   return (
//     <div>
//       {row.lastModified ? <FormattedDate value={row.lastModified} /> : row.creationDate && <FormattedDate value={row.creationDate} />}
//       {row.lastModified &&
//         <IconButton tooltip='Oznámení podáno po výzvě k doplnění.' tooltipPosition="top-left"
//           style={{ padding: 0, paddingLeft: 5, marginRight: -15, width: '15px', height: '15px', verticalAlign: 'text-bottom' }}
//           iconStyle={{ width: '15px', height: '15px' }}>
//           <Help color="grey" />
//         </IconButton>}
//     </div>
//   )
// }

export default (props) => {
  const columns = [
    {
      field: 'digitalActCertificate',
      filterable: false,
      sortable: false,
      label: '',
      type: ColumnType.JSX,
      jsx: row => {
        return row.hasDigitalActCertificate ? (
            <Tooltip
                title="Osvědčení o digitálním úkonu"
                placement="top"
                arrow
                enterDelay={200}
            >
              <FactCheckOutlinedIcon style={{
                width: 18,
                height: 18,
                display: "block",
                color: "rgb(35, 98, 162)",
                margin: ((props.editing || props.deleting || props.allowCheck) ? "0 -10px" : "0 -10px 0 10px")
              }} onClick={(e) => {
                e.stopPropagation();
                props.downloadDigitalActCertificate(row.id);
              }}></FactCheckOutlinedIcon >
            </Tooltip>
        ) : null;
      }
    },
    {
      field: "type.name",
      displayField: "type",
      label: "Druh oznámení",
      enum: StatementTypeGrid,
      type: ColumnType.ENUM,
      width: "25%",
      filterItems: [
        { id: "Vstupní", label: "Vstupní" },
        { id: "Průběžné", label: "Průběžné" },
        { id: "Výstupní", label: "Výstupní" },
      ],
    },
    {
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: StatementState,
      type: ColumnType.ENUM,
      filterItems: StatementStateFilterItems,
      width: "9%",
    },
    {
      field: "creationDate",
      label: "Datum podání oznámení",
      type: ColumnType.DATE,
      //jsx: row => showLastDate(row),
      width: "9%",
    },
    {
      field: "lastSaved",
      label: "Datum poslední změny",
      type: ColumnType.DATE,
      width: "9%",
    },
    {
      field: "fromDate",
      label: "Období od",
      type: ColumnType.DATE,
      width: "9%",
    },
    {
      field: "toDate",
      label: "Období do",
      type: ColumnType.DATE,
      width: "9%",
    },
    {
      field: "actinos",
      disableOnRowClick: true,
      label: "Akce",
      type: ColumnType.JSX,
      width: "30%",
      sortable: false,
      jsx: (row) => {
        if (row.state === StatementStateRaw.ACCEPT) {
          return (
              <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: 5,
                    paddingLeft: 5
                  }}
              >
                <Button
                    className="grid-template-button"
                    label="Použít jako šablonu"
                    labelStyle={{ fontSize: 10, padding: 7, display: "block" }}
                    style={{ lineHeight: "auto", height: "auto" }}
                    disabled={row.useAsTemplateDisabled}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onUseAsTemplate && props.onUseAsTemplate(row)
                    }}
                />
                {row.useAsTemplateDisabled && (<ActionHelpPopover text="Toto oznámení nelze použít jako šablonu, jelikož bylo podáno prostřednictvím datové schránky. " />)}
                {!row.useAsTemplateDisabled && (<ActionHelpPopover text="Tuto funkci můžete využít při podávání dalšího oznámení; v rámci použití této funkce, budou propsány do nového oznámení Vámi již dříve vyplněné položky z podaného oznámení, které je možné dále měnit a upravovat i po změně druhu oznámení." />)}
              </div>
          );
        }
        if (row.state === StatementStateRaw.NEW) {
          return (
              <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: 5,
                    paddingLeft: 5
                  }}
              >
                <Button
                    className="grid-delete-button"
                    label="Smazat"
                    labelStyle={{ fontSize: 10, padding: 7, display: "block" }}
                    style={{ lineHeight: "auto", height: "auto" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onDelete && props.onDelete(row.id);
                    }}
                />
              </div>
          );
        }
        return null;
      },
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const StatementGridInternal = (props) => {
  const columns = [
    {
      field: 'digitalActCertificate',
      filterable: false,
      sortable: false,
      label: '',
      type: ColumnType.JSX,
      width: "2%",
      jsx: row => {
        return row.hasDigitalActCertificate ? (
          <Tooltip
              title="Osvědčení o digitálním úkonu"
              placement="top"
              arrow
              enterDelay={200}
          >
            <FactCheckOutlinedIcon style={{
              width: 18,
              height: 18,
              display: "block",
              color: "rgb(35, 98, 162)",
              margin: ((props.editing || props.deleting || props.allowCheck) ? "0 -10px" : "0 -10px 0 10px")
            }} onClick={(e) => {
              e.stopPropagation();
              props.downloadDigitalActCertificate(row.id);
            }}></FactCheckOutlinedIcon >
          </Tooltip>
        ) : null;
      }
    },
    {
      field: "type.name",
      displayField: "type",
      label: "Druh oznámení",
      enum: StatementTypeGrid,
      type: ColumnType.ENUM,
      width: "30%",
    },
    {
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: StatementStateInternal,
      type: ColumnType.ENUM,
      filterItems: StatementStateFilterItems,
      width: "10%",
    },
    {
      field: "creationDate",
      label: "Datum podání oznámení",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      field: "fromDate",
      label: "Období od",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      field: "toDate",
      label: "Období do",
      type: ColumnType.DATE,
      width: "10%",
    }
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const StatementGridOvm = (props) => {
  const columns = [
    {
      field: "type.name",
      displayField: "type",
      label: "Druh oznámení",
      enum: StatementTypeGrid,
      type: ColumnType.ENUM,
      width: "40%",
    },
    {
      field: "creationDate",
      label: "Datum podání oznámení",
      type: ColumnType.DATE,
      //jsx: row => showLastDate(row),
      width: "60%",
    }
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const StatementGridPublic = (props) => {
  const columns = [
    {
      field: "type.name",
      displayField: "type",
      label: "Druh oznámení",
      enum: StatementTypeGrid,
      type: ColumnType.ENUM,
      width: "30%",
    },
    {
      field: "creationDate",
      label: "Datum podání oznámení",
      type: ColumnType.DATE,
      //jsx: row => showLastDate(row),
      width: "20%",
    },
    {
      field: "fromDate",
      label: "Období od",
      type: ColumnType.DATE,
      width: "15%",
    },
    {
      field: "toDate",
      label: "Období do",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      field: "visibility",
      label: "Viditelnost",
      enum: Visibility,
      type: ColumnType.ENUM,
      width: "10%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const StatementGridAllAdminForOfficialDetail = props => {
  const columns = [
    {
      field: 'digitalActCertificate',
      filterable: false,
      sortable: false,
      label: '',
      type: ColumnType.JSX,
      jsx: row => {
        return row.hasDigitalActCertificate ? (
          <Tooltip
              title="Osvědčení o digitálním úkonu"
              placement="top"
              arrow
              enterDelay={200}
          >
            <FactCheckOutlinedIcon style={{
              width: 18,
              height: 18,
              display: "block",
              color: "rgb(35, 98, 162)",
              margin: ((props.editing || props.deleting || props.allowCheck) ? "0 -10px" : "0 -10px 0 10px")
            }} onClick={(e) => {
              e.stopPropagation();
              props.downloadDigitalActCertificate(row.id);
            }}></FactCheckOutlinedIcon >
          </Tooltip>
        ) : null;
      }
    },
    {
      field: 'sequenceNumber',
      displayField: 'sequenceNumber',
      label: '#',
      type: ColumnType.JSX,
      width: '5%',
      jsx: (row) => {
        return row.sequenceNumber ? '#' + row.sequenceNumber : '';
      },
      sortable: true,
      sortBy: 'firstSubmitted;creationDate;lastModified;created'
    },
    {
      field: 'type.name',
      displayField: 'type',
      label: 'Druh oznámení',
      enum: StatementTypeGrid,
      type: ColumnType.ENUM,
      width: '30%'
    },
    {
      field: 'state.name',
      displayField: 'state',
      label: 'Stav',
      enum: StatementStateInternal,
      type: ColumnType.ENUM,
      filterItems: StatementStateFilterItems,
      width: '10%'
    },
    {
      field: 'creationDate',
      label: 'Datum podání oznámení',
      type: ColumnType.DATE,
      //jsx: row => showLastDate(row),
      width: '10%',
    },
    {
      field: 'lastModified',
      label: 'Datum úpravy oznámení',
      type: ColumnType.DATE,
      width: '10%',
    },
    {
      sortable: false,
      field: 'inspection',
      label: 'Kontrola',
      type: ColumnType.JSX,
      width: '15%',
      jsx: row => {
        return <InspectionStatementControl statement={row} administrativeAutorities={props.administrativeAutorities} onInspectionResult={props.onStatementInspectionResult} onInspectionEdit={props.onInspectionEdit}/>;
      }
    },
    {
      field: 'fromDate',
      label: 'Období od',
      type: ColumnType.DATE,
      width: '10%'
    },
    {
      field: 'toDate',
      label: 'Období do',
      type: ColumnType.DATE,
      width: '10%'
    },
    {
      field: 'versionsToggle',
      disableOnRowClick: true,
      label: '',
      type: ColumnType.JSX,
      width: '5%',
      sortable: false,
      jsx: (row, actions) => {
        const versions = (row.statementVersions || []).filter((version) => version.state === StatementStateRaw.ACCEPT);
        if(row.state !== StatementStateRaw.ACCEPT || versions.length <= 1) {
          return null;
        }
        return (
            <Button
                label="Verze"
                labelStyle={{ fontSize: 10, padding: 5, display: "block" }}
                style={{ lineHeight: "auto", height: "auto" }}
                onClick={(e) => {
                  e.stopPropagation();
                  actions.toggleRowMasterDetail && actions.toggleRowMasterDetail(row.id);
                }}
            />
        );
      }
    }
  ];

  const masterDetail = {
    render: (row) => {
      const versions = (row.statementVersions || []).filter((version) => version.state === StatementStateRaw.ACCEPT).sort((a, b) => new Date(b.versionDateTime) - new Date(a.versionDateTime));
      if(row.state !== StatementStateRaw.ACCEPT || versions.length <= 1) {
        return null;
      }

      const { editing, deleting, allowCheck } = props;
      const displayActionCheckbox = (editing || deleting || allowCheck);

      return (
        <>
          <tr className="statementsVersions__masterDetail md__header">
            {displayActionCheckbox && <td className="md__blank" colSpan={1}></td>}  
            <td colSpan={1}>Verze</td>
            <td colSpan={2}>Platnost od (Odesláno)</td>
            <td colSpan={1}>Platnost do</td>
            <td colSpan={3}></td>
          </tr>
          {versions.map((version, index) => (
            <tr key={index} className={
                "statementsVersions__masterDetail md__row" +
                (index === versions.length - 1 ? " md__row--last" : "")
              }>
              {displayActionCheckbox && <td colSpan={1}></td>}
              <td colSpan={1}>
                <div>{index === 0 ? <b>Aktuální</b> : `Verze ${versions.length - index}`}</div>
              </td>
              <td colSpan={2}>
                <FormattedDate value={version.versionDateTime} /> <FormattedTime value={version.versionDateTime} />
              </td>
              <td colSpan={1}>
                {index > 0 && versions[index - 1] ? (
                  <>
                    <FormattedDate value={versions[index - 1].versionDateTime} /> <FormattedTime value={versions[index - 1].versionDateTime} />
                  </>
                ) : <span><b>Aktuální</b></span>}
              </td>
              <td colSpan={3} className="md__actions">
                <Button
                  className="action-button"
                  label="Detail"
                  labelStyle={{ fontSize: 10, padding: 7, display: "block" }}
                  onClick={(e) => {
                    props.onMasterDetailOpen({ validTo: versions[index - 1]?.versionDateTime, version, prevVersion: versions[index + 1], statementId: version.id});
                  }}
                />
              </td>
            </tr>
          ))}
        </>
      )
    }
  }

  return <CommonGrid {...props} columns={columns} masterDetail={masterDetail} />;
};

export const StatementGridRozpracovane = (props) => {
  const columns = [
    {
      field: 'sequenceNumber',
      displayField: 'sequenceNumber',
      label: '#',
      type: ColumnType.JSX,
      width: '5%',
      jsx: (row) => {
        return row.sequenceNumber ? '#' + row.sequenceNumber : '';
      },
      sortable: true,
      sortBy: 'created'
    },
    {
      field: "type.name",
      displayField: "type",
      label: "Druh oznámení",
      enum: StatementTypeGrid,
      type: ColumnType.ENUM,
      width: "30%",
    },
    {
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: StatementStateInternal,
      type: ColumnType.ENUM,
      filterItems: StatementStateFilterItems,
      width: "10%",
    },
    {
      field: "created",
      label: "Datum vytvoření",
      type: ColumnType.DATE,
      width: "12%",
    },
    {
      field: "lastSaved",
      label: "Datum poslední změny",
      type: ColumnType.DATE,
      width: "17%",
    },
    {
      field: "fromDate",
      label: "Období od",
      type: ColumnType.DATE,
      width: "13%",
    },
    {
      field: "toDate",
      label: "Období do",
      type: ColumnType.DATE,
      width: "13%",
    }
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const StatementGridRozpracovaneAllAdmin = (props) => {
  const columns = [
    {
      field: 'sequenceNumber',
      displayField: 'sequenceNumber',
      label: '#',
      type: ColumnType.JSX,
      width: '5%',
      jsx: (row) => {
        return row.sequenceNumber ? '#' + row.sequenceNumber : '';
      },
      sortable: true,
      sortBy: 'created'
    },
    {
      field: "type.name",
      displayField: "type",
      label: "Druh oznámení",
      enum: StatementTypeGrid,
      type: ColumnType.ENUM,
      width: "30%",
    },
    {
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: StatementStateInternal,
      type: ColumnType.ENUM,
      filterItems: StatementStateFilterItems,
      width: "10%",
    },
    {
      field: "created",
      label: "Datum vytvoření",
      type: ColumnType.DATETIME,
      width: "12%",
    },
    {
      field: "lastSaved",
      label: "Datum poslední změny",
      type: ColumnType.DATE,
      width: "17%",
    },
    {
      field: "fromDate",
      label: "Období od",
      type: ColumnType.DATE,
      width: "13%",
    },
    {
      field: "toDate",
      label: "Období do",
      type: ColumnType.DATE,
      width: "13%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};